import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useFormikContext } from "formik";

const NormalChequeForm = () => {
  const form = useFormikContext();
  return (
    <div className="p-2 flex flex-col gap-6">
      <BasicTextInput textArea label="توضیحات" onChange={(val) => form.setFieldValue("description", val)} />
    </div>
  );
};

export default NormalChequeForm;
